<template>
  <v-app>
    <AppSidenav />
    <AppToolbar />
    <v-main>
      <router-view />
    </v-main>
    <AppFooter v-if="!isMessagesRoute" />
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

import AppToolbar from '@/components/Toolbar/AppToolbar'
import AppSidenav from '@/components/AppSidenav'
import AppFooter from '@/components/AppFooter'

import VisitorJob from '@/mixins/visitor-job'

export default {
  components: {
    AppToolbar,
    AppSidenav,
    AppFooter
  },
  mixins: [VisitorJob],
  computed: {
    isMessagesRoute () {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return this.$route.name === 'Conversation' || this.$route.name === 'Threads'
      }
      return null
    }
  },
  created () {
    // initiate subscriber
    this.subscribeUnreadCount()
  },
  methods: {
    ...mapActions('messageNotifications', { subscribeUnreadCount: 'subscribeUnreadCount' })
  }
}
</script>

<style>
@media (min-width: 1264px) {
 .container {
  max-width: 1187px !important;
 }
}
</style>
